import { createAsyncThunk } from '@reduxjs/toolkit';
import { showToast } from '@/store/notifications/slice';
import chevron from '@/services/chevron';
import { isNetworkError } from '@/utils/helperFunc';
import type { BrandProfile } from './types';

export const updateBrandProfile = createAsyncThunk<BrandProfile, { id: string; name: string }>(
  'brandProfiles/updateBrandProfile',
  async ({ id, name }, { dispatch }) => {
    const url = `${import.meta.env.VITE_API_STARGATE}/builder4/brand-profiles/${id}`;
    try {
      const result = await chevron.http({
        url,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: { name },
      });
      dispatch(showToast({ text: 'Brand profile renamed.', state: 'success' }));
      return result as BrandProfile;
    } catch (error) {
      dispatch(showToast({ text: 'Failed to rename brand profile.', state: 'error' }));
      throw error;
    }
  },
);

export const fetchBrandProfileList = createAsyncThunk<BrandProfile[]>(
  'brandProfiles/fetchBrandProfileList',
  async (_, { dispatch }) => {
    const url = `${import.meta.env.VITE_API_STARGATE}/builder4/brand-profiles`;
    try {
      return (await chevron.http({
        url,
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      })) as BrandProfile[];
    } catch (error) {
      const isNetworkErr = isNetworkError(error);

      if (isNetworkErr) {
        dispatch(
          showToast({ text: 'Cannot load brand profiles. Check connection.', state: 'warning' }),
        );
      } else {
        dispatch(
          showToast({ text: 'Failed to load brand profiles. Please try again.', state: 'error' }),
        );
      }
      throw error;
    }
  },
);
